import { MenuItem } from '@type/menu.type';
import { UserRole } from '@type/user.type';
import { KeyService } from '@service/key.service';
import { Module } from '@type/module.type';

export class MenuHelper {

  static getMenuStructure(): MenuItem[] {
    return [
      {
        label: 'Operator',
        icon: 'pi-truck',
        routerLink: '/operator',
        availableRoles: [
          UserRole.operator,
          UserRole.admin,
        ],
      },
      {
        label: 'KMS',
        icon: 'pi-key',
        routerLink: '/kms',
        availableRoles: [
          UserRole.admin,
          UserRole.keymaster,
        ],
      },
      {
        label: 'WMS',
        icon: 'pi-box',
        routerLink: '/wms',
        availableRoles: [UserRole.porter],
      },
      {
        label: 'Administrator',
        icon: 'pi-cog',
        routerLink: '/admin',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
      },
    ];
  }

  static getNavbarMenuStructure(keyService: KeyService): MenuItem[] {
    return [
      {
        label: 'Users',
        icon: 'pi-user',
        routerLink: 'admin/users',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Routes',
        icon: 'pi-sitemap',
        routerLink: 'admin/routes',
        availableRoles: [
          UserRole.admin,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Clients',
        icon: 'pi-id-card',
        routerLink: 'admin/clients',
        availableRoles: [
          UserRole.admin,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Yards',
        icon: 'pi-warehouse',
        routerLink: 'admin/yards',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Reports',
        icon: 'pi-chart-bar',
        routerLink: 'admin/reports',
        availableRoles: [
          UserRole.admin,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Vans',
        icon: 'pi-truck',
        routerLink: 'admin/vans',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Vehicles',
        icon: 'pi-car',
        routerLink: 'admin/vehicles',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.admin],
      },
      {
        label: 'Orders',
        icon: 'pi-list',
        routerLink: 'operator/orders/current',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.operator],
      },
      {
        label: 'Archive',
        icon: 'pi-history',
        routerLink: 'operator/orders/archive',
        availableRoles: [
          UserRole.admin,
          UserRole.operator,
        ],
        availableModules: [Module.operator],
      },
      {
        label: 'Key Check-In',
        icon: 'pi-key',
        routerLink: 'kms/key-checkin',
        disabled: !keyService.selectedYard,
        availableRoles: [
          UserRole.admin,
          UserRole.keymaster,
        ],
        availableModules: [Module.kms],
      },
      {
        label: 'Key Check-Out',
        icon: 'pi-user',
        routerLink: 'kms/key-checkout',
        disabled: !keyService.selectedYard,
        availableRoles: [
          UserRole.admin,
          UserRole.keymaster,
        ],
        availableModules: [Module.kms],
      },
      {
        label: 'Reports',
        icon: 'pi-chart-bar',
        routerLink: 'kms/reports',
        disabled: !keyService.selectedYard,
        availableRoles: [
          UserRole.admin,
          UserRole.keymaster,
        ],
        availableModules: [Module.kms],
      },
    ];
  }
}
